var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiamondGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 42,
    viewBox: "0 0 51 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3433 41.0092L1.01633 18.4969C0.728015 18.2821 0.655942 17.8818 0.854192 17.5826L8.21823 6.33513C8.36377 6.11283 8.56801 5.93845 8.81127 5.82753L12.664 4.06971C12.9412 3.94311 13.2308 3.84831 13.5306 3.78862L29.8483 0.498329C30.0734 0.45136 30.3019 0.42086 30.5327 0.401341L34.7986 0.046885C35.1674 0.0157702 35.5364 0.0819964 35.8721 0.235393L50.413 6.89492C50.7359 7.04238 50.8635 7.43399 50.6901 7.74231L32.2568 40.8157C32.0731 41.1434 31.6454 41.2355 31.3439 41.012L31.3433 41.0092Z",
    fill: "#04211B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.45 13.3156L1.39562 17.9573L8.90795 6.48702L13.241 4.49147L11.45 13.3156Z",
    fill: "#0A7A6A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7428 40.4852L1.39535 17.9571L11.447 13.316C18.2121 22.3715 24.9777 31.4297 31.7428 40.4852Z",
    fill: "#096051"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7414 40.4823L35.1168 20.1414L37.1463 7.91595L45.4313 7.6166L50.159 7.44364L31.7414 40.4823Z",
    fill: "#10E2C8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1576 7.44468L37.1427 7.9203L30.2754 1.05176L35.281 0.631752L50.1576 7.44468Z",
    fill: "#0FEAD5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1435 7.9181C28.5785 9.71677 20.0106 11.516 11.4456 13.3147L13.2366 4.4905L30.2734 1.05013L37.1435 7.9181Z",
    fill: "#0AA092"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.8,
    d: "M30.2761 1.05094L20.2127 7.44764L37.1435 7.91948L30.2761 1.05094Z",
    fill: "url(#paint0_linear_9784_147385)"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2754 1.05176L39.987 4.59688L35.281 0.631752L30.2754 1.05176Z",
    fill: "url(#paint1_linear_9784_147385)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1454 7.91917L28.7112 21.8219L11.4502 13.3152L37.1454 7.91917Z",
    fill: "url(#paint2_linear_9784_147385)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1156 20.1414L28.7065 21.8253L37.1451 7.91591L35.1156 20.1414Z",
    fill: "url(#paint3_linear_9784_147385)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7397 40.4825L11.4473 13.3154L28.7061 21.8255L31.7397 40.4825Z",
    fill: "url(#paint4_linear_9784_147385)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.739 40.4813L28.7053 21.8244L35.1144 20.1404L31.739 40.4813Z",
    fill: "#10E2C8"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.39,
    d: "M31.7414 40.4823L35.1168 20.1414L37.1463 7.91595L45.4313 7.6166L39.4797 8.69233L45.3984 10.0813L38.3982 9.12425L42.6776 15.0948L37.6419 9.90653L37.4942 10.6678L31.7414 40.4823Z",
    fill: "url(#paint5_linear_9784_147385)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7,
    d: "M25.7885 22.3032C22.9992 19.7399 16.2189 10.7077 15.1181 4.11399L30.275 1.05443L35.1289 0.648886C36.5504 3.53481 40.4583 10.5253 38.1248 17.0106C35.1586 25.255 29.5216 25.738 25.7891 22.3059L25.7885 22.3032Z",
    fill: "url(#paint6_linear_9784_147385)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M31.7469 1.92979L37.0183 3.44234L31.6649 1.38546L35.2719 0.632812L30.269 1.05224L25.3039 2.03672L29.4149 1.64011L25.0647 4.36395L30.2028 1.61321L34.628 5.41348L31.7469 1.92979Z",
    fill: "url(#paint7_linear_9784_147385)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9784_147385",
    x1: 43.3037,
    y1: 0.869043,
    x2: 23.5558,
    y2: 8.31165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10E2C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F890BE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9784_147385",
    x1: 30.7973,
    y1: -1.36175,
    x2: 38.3988,
    y2: 5.98484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#10E2C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#12E1C7",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#1BDEC7",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#2AD8C6",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#3ED1C5",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#5AC7C4",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#7BBCC3",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#A3ADC1",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#CF9EBF",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F890BE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9784_147385",
    x1: 23.3213,
    y1: 5.50864,
    x2: 26.478,
    y2: 22.0347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#096051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#096556"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#097666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#0B9281"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0CB8A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#0EE9D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0FEAD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9784_147385",
    x1: 29.2189,
    y1: -4.41407,
    x2: 33.7991,
    y2: 19.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#096051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#096858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#0A7E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#0BA391"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#0ED5C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0FEAD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9784_147385",
    x1: 12.4887,
    y1: -21.9097,
    x2: 24.073,
    y2: 38.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#096051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#096858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#0A7E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#0BA391"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#0ED5C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0FEAD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9784_147385",
    x1: 41.1553,
    y1: 2.63589,
    x2: 37.7531,
    y2: 32.4307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1EAD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#E1EBD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#E3F0E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E6F9F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#E7FCF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_9784_147385",
    x1: 32.6962,
    y1: -8.59448,
    x2: 23.2167,
    y2: 21.3039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FECD00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FED645",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FEDE80",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FEE4AE",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FEE9CF",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#FEECE3",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FEEDEA",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_9784_147385",
    x1: 27.3739,
    y1: -1.01628,
    x2: 31.9834,
    y2: 4.77941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FECD00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FED645",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FEDE80",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FEE4AE",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FEE9CF",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#FEECE3",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FEEDEA",
    stopOpacity: 0.6
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondGreen);
export default __webpack_public_path__ + "static/media/diamond-green.0c9a8a11cfb9e6f4a3ce89660133f0db.svg";
export { ForwardRef as ReactComponent };